import styled, {css} from 'styled-components';
import {
  black,
  spacing,
  fontBigger,
  fontNormalBig,
  fontSmall,
  fontBiggest,
  smallDevices,
  fontNormal,
} from '@propellerads/stylevariables';

const commonStyle = css`
    margin: 0;
    padding: 0;
    line-height: 1.2;
    font-weight: 700;
    color: ${black};
`;

const H1 = styled.h1`
  ${commonStyle}
  margin-bottom: ${spacing * 4}px;
  font-size: ${fontBigger}px;
  
  @media (min-width: ${smallDevices}px) {
    font-size: ${fontBiggest}px;
  }
`;

const H2 = styled.h2`
  ${commonStyle}
  margin-bottom: ${spacing * 3}px;
  font-size: ${fontNormalBig}px;
  
  @media (min-width: ${smallDevices}px) {
    font-size: ${fontBigger}px;
  }
`;

const H3 = styled.h3`
  margin-bottom: ${spacing * 2}px;
  font-size: ${fontNormalBig}px;
  ${commonStyle}
`;

const H4 = styled.h4`
  ${commonStyle}
  margin-bottom: ${spacing * 2}px;
  font-size: ${fontSmall}px;
  
  @media (min-width: ${smallDevices}px) {
    font-size: ${fontNormal}px;
  }
`;

export {
  H1,
  H2,
  H3,
  H4,
};
